import { observer } from 'mobx-react-lite';
import React from 'react';
import FormWrapper from 'src/app/form/FormWrapper';
import CellNumberField from 'src/components/forms/inputfields/Register/CellNumberField';
import WorkNumberField from 'src/components/forms/inputfields/Register/WorkNumberField';
import CompanyNameField from 'src/components/forms/inputfields/Register/CompanyNameField';
import ConfirmPasswordField from 'src/components/forms/inputfields/Register/ConfirmPasswordField';
import EmailField from 'src/components/forms/inputfields/Register/EmailField';
import FirstNameField from 'src/components/forms/inputfields/Register/FirstNameField';
import LastNameField from 'src/components/forms/inputfields/Register/LastNameField';
import PasswordField from 'src/components/forms/inputfields/Register/PasswordField';
import UsernameField from 'src/components/forms/inputfields/Register/UsernameField';
import ProfileModel from 'src/models/account/ProfileModel';
import { FlexContainer, PaddedBox } from 'src/components/base/container';
import { PageTitle } from 'src/components/base/styledComponents';
import AddressField from 'src/components/forms/inputfields/Register/AddressField';
import CountryField from 'src/components/forms/inputfields/Register/CountryField';
import ProvinceField from 'src/components/forms/inputfields/Register/ProvinceField';
import ProvinceTextField from 'src/components/forms/inputfields/Register/ProvinceTextField';
import FormDisclaimer from './FormDisclaimer';
import EmailListField from 'src/components/forms/inputfields/Register/EmailListField';
import TermsAndConditionsField from 'src/components/forms/inputfields/Register/TermsAndConditionsField';
import Recaptcha from 'src/components/forms/recaptcha/Recaptcha';
import PostalCodeZipField from 'src/components/forms/inputfields/Register/PostalCodeZipField';
import { SuccessButton } from 'src/containers/ActiveAuctions/components/styledComponents';
import { CheckBoxFlex, VariableFlex } from './styledComponents';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import CityField from 'src/components/forms/inputfields/Register/CityField';
import { stringIsNullOrEmpty } from 'src/utils/helpers/stringHelpers';
import { useUtilityStore } from 'src/stores/useMobxStores';
import RegisterSuccessModal from './RegisterSuccessModal';
import RegistrationService from 'src/services/User/RegistrationService';

const RegisterAccountForm: React.FC = () => {
  const [model] = React.useState(new ProfileModel(true));
  const [loading, setLoading] = React.useState<boolean>(false);
  const history = useHistory();

  const utilityStore = useUtilityStore();

  const onSubmit = React.useCallback(() => {
    const submit = async () => {
      setLoading(true);
      const registrationService = new RegistrationService();
      const response = await registrationService.register(model);
      if (response.data.success) {
        history.push('/');
        utilityStore.openModal(<RegisterSuccessModal />);
      } else {
        toast.error('Error creating account');
        console.log(response.data.errors)
      }
      setLoading(false);
    };
    if (stringIsNullOrEmpty(model.workPhone)) {
      model.workPhone = model.cellPhone;
    }
    if (stringIsNullOrEmpty(model.businessName)) {
      model.businessName = model.firstName + ' ' + model.lastName;
    }
    submit();
  }, [model]);
  //because react doesnt like having two key the same in a list, and they NEED both of these even though you can type in the input?
  const onChangeCountry = React.useCallback(() => {
    switch (model.country) {
      case 'Canada ':
      case 'Canada':
      case 'United States':
      case 'United States ':
        return <ProvinceField model={model} country={model}/>;
      default:
        return <ProvinceTextField model={model} />;
    }
  }, [model.country]);

  return (
    <FormWrapper onSubmit={onSubmit}>
      <PageTitle subHeader>Account Information</PageTitle>
      <FlexContainer column rowGap={'10px'}>
        <FlexContainer justifyContent='center' column rowGap={'10px'}>
          <EmailField model={model} />
          <UsernameField model={model} />
        </FlexContainer>
        <VariableFlex>
          <PasswordField model={model} />
          <ConfirmPasswordField model={model} />
        </VariableFlex>
      </FlexContainer>
      <PageTitle subHeader>Member Information</PageTitle>
      <VariableFlex>
        <FirstNameField model={model} />
        <LastNameField model={model} />
      </VariableFlex>
      <FlexContainer column rowGap={'10px'}>
        <CompanyNameField model={model} />
        <AddressField model={model} />
        <CityField model={model} />
        <VariableFlex>
          <CountryField model={model} />
          {onChangeCountry()}
        </VariableFlex>
        <PostalCodeZipField model={model} />
        <CellNumberField model={model} isRequired/>
        <WorkNumberField model={model} />
      </FlexContainer>
      <FormDisclaimer />
      <PaddedBox>
        <CheckBoxFlex>
          <EmailListField model={model} />
          <TermsAndConditionsField model={model} />
        </CheckBoxFlex>
      </PaddedBox>
      <PaddedBox>
        <CheckBoxFlex>
          <Recaptcha model={model} />
          <SuccessButton type='submit' disabled={!model.notARobot || !model.policy || loading}>
            CREATE ACCOUNT
          </SuccessButton>
        </CheckBoxFlex>
      </PaddedBox>
    </FormWrapper>
  );
};

export default observer(RegisterAccountForm);

// <LegacySiteIntegrationLink oldUrl={'/Account/LostPassword'}>
//   <Recover>Recover Account</Recover>
// </LegacySiteIntegrationLink>;
